
/* injects from baggage-loader */

// $uibModal

'use strict';

export default function (app) {
	app
	.factory('Dialog', DialogFactory);

	function DialogFactory($uibModal) {
		'ngInject';

		let self = {};

		let parentNode = angular.element(document.querySelector('.stage-container'));
		// let parentTutorial = angular.element(document.querySelector('#tutorial-holder'));

		self.showFail = function(text, callback, cancelFn){
			$uibModal.open({
				animation: true,
				component: 'dialogAlert',
				controllerAs: "$ctrl",
				resolve:{
					text: () => text
				}
			}).result.then(callback, cancelFn);
		};

		self.showMenu = function(callback, cancelFn){
			$uibModal.open({
				animation: true,
				component: 'dialogMenu',
				controllerAs: "$ctrl",
			}).result.then(callback, cancelFn);
		};

		self.showFeedback = function (prize, callback, cancelFn) {
			$uibModal.open({
				animation: true,
				component: 'dialogFeedback',
				controllerAs: "$ctrl",
				appendTo: parentNode,
				windowClass: 'feedback-box',
				backdrop: 'static',
				resolve: {
					prize: () =>  prize
				}
			}).result.then(callback, cancelFn);
		};

		self.showTutorial = function (num, callback, cancelFn) {
			$uibModal.open({
				animation: true,
				component: 'dialogTutorial',
				controllerAs: "$ctrl",
				appendTo: parentNode,
				windowClass: 'tutorial-box',
				backdrop: 'static',
				backdropClass: 'tutorial-backdrop',
				resolve: {
					num: () =>  num
				}
			}).result.then(callback, cancelFn);
		};
		
		self.showMatemagico = function (text, name, callback, cancelFn) {
			$uibModal.open({
				animation: true,
				component: 'dialogMatemagico',
				controllerAs: "$ctrl",
				appendTo: parentNode,
				windowClass: 'matemagico-box',
				backdrop: 'static',
				resolve: {
					text: () =>  text,
					name: () =>  name
				}
			}).result.then(callback, cancelFn);
		};

		self.showMission = function (text, icons, callback, cancelFn) {
			$uibModal.open({
				animation: true,
				component: 'dialogMission',
				controllerAs: "$ctrl",
				appendTo: parentNode,
				windowClass: 'mission-box',
				backdrop: 'static',
				resolve: {
					text: () =>  text,
					icons: () =>  icons
				}
			}).result.then(callback, cancelFn);
		};

		self.showAlert = function ( callback, cancelFn) {
			$uibModal.open({
				animation: true,
				component: 'dialogAlert',
				controllerAs: "$ctrl",
				appendTo: parentNode,
				windowClass: 'alert-box',
				backdrop: 'static',
			}).result.then(callback, cancelFn);
		};

		self.showTrophiesModal = function(totalParts, callback, cancelFn){
			$uibModal.open({
				animation: true,
				ariaDescribedBy: 'Parabéns você conseguiu ganhar alguns troféis',
				component: 'dialogTrophies',
				controllerAs: "$ctrl",
				windowClass: 'interventional-modal',
				resolve: {
					totalParts: () => totalParts
				}
			}).result.then(callback, cancelFn);
		};

		self.showImageDownload = function(canvas, username, callback, cancelFn){
			$uibModal.open({
				animation: true,
				ariaDescribedBy: 'Faça o download da imagem',
				component: 'dialogImage',
				controllerAs: '$ctrl',
				windowClass: 'image-downloader',
				resolve: {
					canvas: () => canvas,
					username: () => username
				}
			}).result.then(callback, cancelFn);
		};

		return self;
	}
}



// WEBPACK FOOTER //
// ./src/app/core/services/dialogs.factory.js